module.exports = "https://web-assets.ifttt.com/packs/media/docs/dynamic_dropdown-b89c7d03.gif";